import React, { useCallback, useEffect, useState } from "react";

export type DispSize = {
    width: number,
    height: number
}
interface Props {
    children: React.ReactNode;
}

export const WindowContext = React.createContext<DispSize>({ width: 0, height: 0 });
export const WindowContextProvider: React.FC<Props> = ({ children }) => {
    const getVh = useCallback(() => {
        return document.documentElement.clientHeight || 0;
    }, []);
    const getVw = useCallback(() => {
        return document.documentElement.clientWidth || 0;
    }, []);
    const [height, setVh] = useState<number>(getVh());
    const [width, setVw] = useState<number>(getVw());
    useEffect(() => {
        const handleResize = () => {
            setVh(getVh());
            setVw(getVw());
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [getVh, getVw]);
    return (
        <WindowContext.Provider value={{ width, height }} >
            {children}
        </WindowContext.Provider>
    );
};